import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Input, Button} from 'semantic-ui-react';
import {Actions} from '../../common/actions';

class filterSection extends Component {
  constructor(props) {
    super(props);
    this.handleFilterChange = this.handleFilterChange.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleFilterChange(event, data) {
    const {name, value} = data;
    this.props.changeDealersAgenciesFilter(name, value.toUpperCase());
  }

  handleClearClick() {
    this.props.changeDealersAgenciesFilter();
  }

  render() {
    const {code, dealer} = this.props;
    return (
      <Card raised fluid className='filter-section'>
        <Grid>
          <Grid.Row>
            <Grid.Column width='3'>
              <Input fluid
                name='dealer'
                placeholder='Concesionario'
                onChange={this.handleFilterChange}
                value={dealer}
              />
            </Grid.Column>
            <Grid.Column width='2'>
              <Input fluid
                name='code'
                placeholder='Agencia'
                maxLength='20'
                onChange={this.handleFilterChange}
                value={code}
              />
            </Grid.Column>
            <Grid.Column width='11' textAlign='right'>
              <Button secondary onClick={this.handleClearClick}>Limpiar</Button>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {code = '', dealer = ''} = state.dealer.agenciesFilters;
  return {code, dealer};
};

const {changeDealersAgenciesFilter} = Actions;

export default connect(mapStateToProps, {changeDealersAgenciesFilter})(filterSection);
